export const V = '2121121';
export const COUCH_URL = 'https://db.btsdev.pt';
export const COUCH_DATABASE = 'bts-demo'
export const IDLE_TIME = 30000
export const HEARTBEAT_DB_TIME = 10000
export const OCR_INSTALLED = true;
//export const API_ENDPOINT = 'http://localhost:3000/api/v1';
//export const API_ENDPOINT = 'http://servidor.brandtellers.com:1234/api/v1';
export const API_ENDPOINT = 'https://backend.besttradeshowapp.com/api/v1';